export const STICK_TO_SET_QUESTIONS_SUBTITLE =
  'Use your preset questions for candidates who apply directly';

export const PASSIVE_CANDIDATE_SCREENING_CALLOUT = [
  'These preset questions are only used for direct applicants.',
  "When your AI recruiter reaches out to passive candidates, it won't use them.",
  'Those conversations stay focused on introducing the role and gauging interest.',
].join(' ');
